// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1rjUp","header":"PatientQuestionnaire_header__1TU50","info":"PatientQuestionnaire_info__3csEU"};